const REASON_KEYS = {
    missing_email: 'missingEmail',
    invalid_email: 'invalidEmail',
    invalid_name: 'invalidName',
    invalid_phone: 'invalidPhone',
    missing_mandatory_fields: 'missingMandatoryFields',
    missing_customer_name: 'missingCustomerName',
    invalid_customer_type: 'invalidCustomerType',
    multiple_customers_share_name: 'multipleCustomersShareName',
    customer_id_not_found: 'customerIdNotFound',
    matches_sample_customer: 'matchesSampleCustomer',
    processing_error: 'processingError'
};
const reasonTextFor = (reason, texts)=>texts.rejectionReason[REASON_KEYS[reason]]();
export const rejectionLine = (param, texts)=>{
    let { reason, rowNumber, contact } = param;
    const reasonText = reasonTextFor(reason, texts);
    if (contact == null) return reasonText;
    const { firstName, lastName, email } = contact;
    const hasName = firstName.trim().length > 0 || lastName.trim().length > 0;
    const hasEmail = email.trim().length > 0;
    if (hasName && hasEmail) {
        return texts.rejectionLine.withNameAndEmail({
            firstName,
            lastName,
            email,
            reason: reasonText
        });
    }
    if (hasName) return texts.rejectionLine.nameOnly({
        firstName,
        lastName,
        reason: reasonText
    });
    if (hasEmail) return texts.rejectionLine.emailOnly({
        email,
        reason: reasonText
    });
    return texts.rejectionLine.rowNumber({
        rowNumber,
        reason: reasonText
    });
};
